import Component from '../abstracts/Component';
import _ from 'lodash';

export default class CollapseComponent extends Component {
  get COMPONENTNAME() {
    return 'CollapseComponent';
  }

  get SELECTORS() {
    return {
      trigger: '[data-trigger]',
      tab: '[data-tab]',
      triggerStartOpen: 'start-open',
    };
  }

  get CLASSES() {
    return {
      collapsed: 'collapsed',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.triggers = this.$component.querySelectorAll(this.SELECTORS.trigger);
    this.tabs = this.$component.querySelectorAll(this.SELECTORS.tab);
    this.currentOpenTrigger = null;
  }

  // Get all the tabs and set the height

  setCollapsibleHeight() {
    return _.debounce(() => {
      if (this.tabs) {
        this.tabs.forEach((tab) => {
          tab.style.height = tab.offsetHeight + 'px';
        });
      }
    }, 300);
  }

  init() {
    this.setCollapsibleHeight();
    if (this.triggers) {
      this.triggers.forEach((trigger) => {
        //get trigger-related tab
        const tab = trigger.parentNode.querySelector(this.SELECTORS.tab);
        if (trigger.dataset.trigger === this.SELECTORS.triggerStartOpen) {
          this.currentOpenTrigger = trigger;
        } else {
          tab.classList.add(this.CLASSES.collapsed);
          trigger.classList.add(this.CLASSES.collapsed);
        }
      });
    }
  }

  //handle click on trigger element
  handleCollapse() {
    if (this.triggers) {
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          //get trigger-related tab
          const tab = trigger.parentNode.querySelector(this.SELECTORS.tab);
          if (this.currentOpenTrigger === trigger) {
            // click on the same trigger to close the section
            trigger.classList.add(this.CLASSES.collapsed);
            tab.classList.add(this.CLASSES.collapsed);
            this.currentOpenTrigger = null;
          } else if (this.currentOpenTrigger != null) {
            //another tab is currently open
            this.currentOpenTrigger.classList.add(this.CLASSES.collapsed);
            //find current open tab to close it
            const currentOpenTab =
              this.currentOpenTrigger.parentNode.querySelector(
                this.SELECTORS.tab
              );
            currentOpenTab.classList.add(this.CLASSES.collapsed);
            trigger.classList.remove(this.CLASSES.collapsed);
            tab.classList.remove(this.CLASSES.collapsed);
            this.currentOpenTrigger = trigger;
          } else {
            //is the first trigger clicked
            trigger.classList.remove(this.CLASSES.collapsed);
            tab.classList.remove(this.CLASSES.collapsed);
            this.currentOpenTrigger = trigger;
          }
        });
      });
    }
  }

  refreshHeight(event, payload) {
    // context
    let ctx = this;
    // check
    if (payload.btn === null) return false;
    // let's find the component
    let comp = payload.btn.closest('[data-js-component]');
    if (comp !== null) {
      comp.querySelector(ctx.SELECTORS.tab).style.height =
        comp.querySelector(ctx.SELECTORS.tab).children[0].offsetHeight + 'px';
    }
  }

  bindEvents() {
    this.handleCollapse();
    this.$on(
      this.$customEvents.COLLAPSE_EVENTS.update,
      ({ event, payload }) => {
        this.refreshHeight(event, payload);
      }
    );
    window.addEventListener('resize', this.setCollapsibleHeight);
  }

  render() {
    this.log('Rendering...');
    super.render();
    this.init();
    this.bindEvents();
  }
}
